export default {
  dealer_groups: [],
  dealer_group: null,
};
